import { ReportServiceInterface } from 'domain/services';
import {
  HandleStudentReportDailyWorkload,
  GetStudentsFrequencyReportUseCaseInterface,
  HandleProfessionalsWorkJourneyUseCaseInterface,
  GetProfessionalsWorkJourneyUseCaseInterface,
  GetStudentsWorkloadAchievementUseCaseInterface,
  ExportStudentsWorkloadAchievementUseCaseInterface,
  HandleActivitiesAnalyticalPerTaskUseCaseInterface,
  HandleActivitiesSummarizedByStudentUseCaseInterface,
  GetConsolidatedActivitiesByStudentUseCaseInterface,
  HandleActivitiesQuantityPerStudentUseCaseInterface,
  HandleSummaryReportByInternshipLocation,
  HandleActivitiesAnalyticalPerGroupUseCaseInterface,
  HandleValidatedByProfessionalsUseCaseInterface,
  HandleRejectedByProfessionalsUseCaseInterface,
  GetStudentsIndividualWorkloadReportUseCaseInterface,
  GetAppRegisteredStudentsPerGroupUseCaseInterface,
  GetNumberStudentsPerProfessionalInFieldUseCaseInterface,
  ExportNumberStudentsPerProfessionalInFieldUseCaseInterface,
  HandleStudentsWithoutRegisteringApp,
  HandleStudentsNoAppUsageUseCaseInterface,
  ActivitiesPendingByProfessionalsUseCaseInterface,
  GetPendingActivitiesPerProfessionalSummaryUseCaseInterface,
  ExportPendingActivitiesPerProfessionalPdfUseCaseInterface,
  ExportPendingActivitiesPerProfessionalExcelUseCaseInterface,
  HandleMissedActivitiesJustificationsUseCaseInterface,
  GetTeamReportList,
  HandleTeamReport,
  GetPerformanceReportForProfessionalsSummaryUseCaseInterface,
  GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface,
  GetPerformanceReportForProfessionalsEvolutionUseCaseInterface,
  GetPerformanceReportForProfessionalsRankingUseCaseInterface,
  ExportPerformanceReportForProfessionalsExcelUseCaseInterface,
  GetProfessionalsDailyWorkloadUseCaseInterface,
  ExportProfessionalsDailyWorkloadExcelUseCaseInterface,
  ExportAccessReportExcelUseCaseInterface,
  GetSuspectedManipulationUseCaseInterface,
  GetSuspectedManipulationCountUseCaseInterface,
  GetSuspectedStudentsRankingUseCaseInterface,
  ExportSuspectedManipulationUseCaseInterface,
  ExportSuspectedStudentsRankingUseCaseInterface,
} from 'domain/usecases';
import { GetActivitiesSummaryByTaskUseCaseInterface } from 'domain/usecases/reports/get-activities-summary-by-task';
import { HandleSummaryReportByGroup } from 'domain/usecases/reports/handle-summary-report-by-group';

export class ReportService implements ReportServiceInterface {
  constructor(
    private readonly _getConsolidatedActivitiesByStudent: GetConsolidatedActivitiesByStudentUseCaseInterface,
    private readonly _getStudentsFrequencyReport: GetStudentsFrequencyReportUseCaseInterface,
    private readonly _getProfessionalsWorkJourney: GetProfessionalsWorkJourneyUseCaseInterface,
    private readonly _handleProfessionalWorkingHours: HandleProfessionalsWorkJourneyUseCaseInterface,
    private readonly _getStudentsIndividualWorkloadReport: GetStudentsIndividualWorkloadReportUseCaseInterface,
    private readonly _handleActivitiesQuantityPerStudent: HandleActivitiesQuantityPerStudentUseCaseInterface,
    private readonly _handleActivitiesAnalyticalPerTask: HandleActivitiesAnalyticalPerTaskUseCaseInterface,
    private readonly _handleStudentReportDailyWorkload: HandleStudentReportDailyWorkload,
    private readonly _handleActivitiesSummarizedByStudent: HandleActivitiesSummarizedByStudentUseCaseInterface,
    private readonly _handleSummaryReportByGroup: HandleSummaryReportByGroup,
    private readonly _getActivitiesSummaryByTask: GetActivitiesSummaryByTaskUseCaseInterface,
    private readonly _handleSummaryReportByInternshipLocation: HandleSummaryReportByInternshipLocation,
    private readonly _handleActivitiesAnalyticalPerGroup: HandleActivitiesAnalyticalPerGroupUseCaseInterface,
    private readonly _handleStudentsWithoutRegisteringApp: HandleStudentsWithoutRegisteringApp,
    private readonly _handleStudentsNoAppUsage: HandleStudentsNoAppUsageUseCaseInterface,
    private readonly _handleValidatedByProfessionals: HandleValidatedByProfessionalsUseCaseInterface,
    private readonly _handleRejectedByProfessionals: HandleRejectedByProfessionalsUseCaseInterface,
    private readonly _getAppRegisteredStudentsPerGroup: GetAppRegisteredStudentsPerGroupUseCaseInterface,
    private readonly _getNumberStudentsPerProfessionalInField: GetNumberStudentsPerProfessionalInFieldUseCaseInterface,
    private readonly _exportNumberStudentsPerProfessionalInField: ExportNumberStudentsPerProfessionalInFieldUseCaseInterface,
    private readonly _activitiesPendingByProfessionals: ActivitiesPendingByProfessionalsUseCaseInterface,
    private readonly _getPendingActivitiesPerProfessionalSummary: GetPendingActivitiesPerProfessionalSummaryUseCaseInterface,
    private readonly _exportPendingActivitiesPerProfessionalPdf: ExportPendingActivitiesPerProfessionalPdfUseCaseInterface,
    private readonly _exportPendingActivitiesPerProfessionalExcel: ExportPendingActivitiesPerProfessionalExcelUseCaseInterface,
    private readonly _handleMissedActivitiesJustifications: HandleMissedActivitiesJustificationsUseCaseInterface,
    private readonly _getTeamReportList: GetTeamReportList,
    private readonly _handleTeamReport: HandleTeamReport,
    private readonly _getPerformanceReportForProfessionalsSummary: GetPerformanceReportForProfessionalsSummaryUseCaseInterface,
    private readonly _getPerformanceReportForProfessionalsTopValidatedActivities: GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface,
    private readonly _getPerformanceReportForProfessionalsEvolution: GetPerformanceReportForProfessionalsEvolutionUseCaseInterface,
    private readonly _getPerformanceReportForProfessionalsRanking: GetPerformanceReportForProfessionalsRankingUseCaseInterface,
    private readonly _exportPerformanceReportForProfessionalsExcel: ExportPerformanceReportForProfessionalsExcelUseCaseInterface,
    private readonly _getProfessionalsDailyWorkload: GetProfessionalsDailyWorkloadUseCaseInterface,
    private readonly _exportProfessionalsDailyWorkloadExcel: ExportProfessionalsDailyWorkloadExcelUseCaseInterface,
    private readonly _exportAccessReportExcel: ExportAccessReportExcelUseCaseInterface,
    private readonly _getSuspectedManipulation: GetSuspectedManipulationUseCaseInterface,
    private readonly _getSuspectedManipulationCount: GetSuspectedManipulationCountUseCaseInterface,
    private readonly _getSuspectedStudentsRanking: GetSuspectedStudentsRankingUseCaseInterface,
    private readonly _exportSuspectedManipulation: ExportSuspectedManipulationUseCaseInterface,
    private readonly _exportSuspectedStudentsRanking: ExportSuspectedStudentsRankingUseCaseInterface,
    private readonly _getStudentsWorkloadAchievement: GetStudentsWorkloadAchievementUseCaseInterface,
    private readonly _exportStudentsWorkloadAchievement: ExportStudentsWorkloadAchievementUseCaseInterface,
  ) {}

  async getConsolidatedActivitiesByStudent(
    params: GetConsolidatedActivitiesByStudentUseCaseInterface.Params,
  ): Promise<GetConsolidatedActivitiesByStudentUseCaseInterface.Result> {
    return await this._getConsolidatedActivitiesByStudent.execute(params);
  }

  async getStudentsFrequencyReport(
    params: GetStudentsFrequencyReportUseCaseInterface.Params,
  ): Promise<GetStudentsFrequencyReportUseCaseInterface.Result> {
    return await this._getStudentsFrequencyReport.execute(params);
  }

  async getProfessionalsWorkJourney(
    params: GetProfessionalsWorkJourneyUseCaseInterface.Params,
  ): Promise<GetProfessionalsWorkJourneyUseCaseInterface.Result> {
    return await this._getProfessionalsWorkJourney.execute(params);
  }

  async handleProfessionalsWorkJourney(
    params: HandleProfessionalsWorkJourneyUseCaseInterface.Params,
  ): Promise<HandleProfessionalsWorkJourneyUseCaseInterface.Result> {
    return await this._handleProfessionalWorkingHours.execute(params);
  }

  async getStudentsIndividualWorkloadReport(
    params: GetStudentsIndividualWorkloadReportUseCaseInterface.Params,
  ): Promise<GetStudentsIndividualWorkloadReportUseCaseInterface.Result> {
    return await this._getStudentsIndividualWorkloadReport.execute(params);
  }

  async handleActivitiesQuantityPerStudent(
    params: HandleActivitiesQuantityPerStudentUseCaseInterface.Params,
  ): Promise<HandleActivitiesQuantityPerStudentUseCaseInterface.Result> {
    return await this._handleActivitiesQuantityPerStudent.execute(params);
  }

  async handleActivitiesAnalyticalPerTask(
    params: HandleActivitiesAnalyticalPerTaskUseCaseInterface.Params,
  ): Promise<HandleActivitiesAnalyticalPerTaskUseCaseInterface.Result> {
    return await this._handleActivitiesAnalyticalPerTask.execute(params);
  }

  async handleStudentReportDailyWorkload(
    params: HandleStudentReportDailyWorkload.Params,
  ): Promise<HandleStudentReportDailyWorkload.Result> {
    return await this._handleStudentReportDailyWorkload.execute(params);
  }

  async handleActivitiesSummarizedByStudent(
    params: HandleActivitiesSummarizedByStudentUseCaseInterface.Params,
  ): Promise<HandleActivitiesSummarizedByStudentUseCaseInterface.Result> {
    return await this._handleActivitiesSummarizedByStudent.execute(params);
  }

  async handleSummaryReportByGroup(
    params: HandleSummaryReportByGroup.Params,
  ): Promise<HandleSummaryReportByGroup.Result> {
    return await this._handleSummaryReportByGroup.execute(params);
  }

  async handleGetActivitySummaryByTask(
    params: GetActivitiesSummaryByTaskUseCaseInterface.Params,
  ): Promise<GetActivitiesSummaryByTaskUseCaseInterface.Result> {
    return await this._getActivitiesSummaryByTask.execute(params);
  }

  async handleSummaryReportByInternshipLocation(
    params: HandleSummaryReportByInternshipLocation.Params,
  ): Promise<HandleSummaryReportByInternshipLocation.Result> {
    return await this._handleSummaryReportByInternshipLocation.execute(params);
  }

  async handleActivitiesAnalyticalPerGroup(
    params: HandleActivitiesAnalyticalPerGroupUseCaseInterface.Params,
  ): Promise<HandleActivitiesAnalyticalPerGroupUseCaseInterface.Result> {
    return await this._handleActivitiesAnalyticalPerGroup.execute(params);
  }

  async getAppRegisteredStudentsPerGroup(
    params: GetAppRegisteredStudentsPerGroupUseCaseInterface.Params,
  ): Promise<GetAppRegisteredStudentsPerGroupUseCaseInterface.Result> {
    return await this._getAppRegisteredStudentsPerGroup.execute(params);
  }

  async getNumberStudentsPerProfessionalInField(
    params: GetNumberStudentsPerProfessionalInFieldUseCaseInterface.Params,
  ): Promise<GetNumberStudentsPerProfessionalInFieldUseCaseInterface.Result> {
    return await this._getNumberStudentsPerProfessionalInField.execute(params);
  }

  async exportNumberStudentsPerProfessionalInField(
    params: ExportNumberStudentsPerProfessionalInFieldUseCaseInterface.Params,
  ): Promise<ExportNumberStudentsPerProfessionalInFieldUseCaseInterface.Result> {
    return await this._exportNumberStudentsPerProfessionalInField.execute(
      params,
    );
  }

  async handleStudentsWithoutRegisteringApp(
    params: HandleStudentsWithoutRegisteringApp.Params,
  ): Promise<HandleStudentsWithoutRegisteringApp.Result> {
    return await this._handleStudentsWithoutRegisteringApp.execute(params);
  }

  async handleStudentsNoAppUsage(
    params: HandleStudentsNoAppUsageUseCaseInterface.Params,
  ): Promise<HandleStudentsNoAppUsageUseCaseInterface.Result> {
    return await this._handleStudentsNoAppUsage.execute(params);
  }

  async handleValidatedByProfessionals(
    params: HandleValidatedByProfessionalsUseCaseInterface.Params,
  ): Promise<HandleValidatedByProfessionalsUseCaseInterface.Result> {
    return await this._handleValidatedByProfessionals.execute(params);
  }

  async handleRejectedByProfessionals(
    params: HandleRejectedByProfessionalsUseCaseInterface.Params,
  ): Promise<HandleRejectedByProfessionalsUseCaseInterface.Result> {
    return await this._handleRejectedByProfessionals.execute(params);
  }

  async handleActivitiesPendingByProfessionals(
    params: ActivitiesPendingByProfessionalsUseCaseInterface.Params,
  ): Promise<ActivitiesPendingByProfessionalsUseCaseInterface.Result> {
    return await this._activitiesPendingByProfessionals.execute(params);
  }
  async getPendingActivitiesPerProfessionalSummary(
    params: GetPendingActivitiesPerProfessionalSummaryUseCaseInterface.Params,
  ): Promise<GetPendingActivitiesPerProfessionalSummaryUseCaseInterface.Result> {
    return await this._getPendingActivitiesPerProfessionalSummary.execute(
      params,
    );
  }
  async exportPendingActivitiesPerProfessionalPdf(
    params: ExportPendingActivitiesPerProfessionalPdfUseCaseInterface.Params,
  ): Promise<ExportPendingActivitiesPerProfessionalPdfUseCaseInterface.Result> {
    return await this._exportPendingActivitiesPerProfessionalPdf.execute(
      params,
    );
  }
  async exportPendingActivitiesPerProfessionalExcel(
    params: ExportPendingActivitiesPerProfessionalExcelUseCaseInterface.Params,
  ): Promise<ExportPendingActivitiesPerProfessionalExcelUseCaseInterface.Result> {
    return await this._exportPendingActivitiesPerProfessionalExcel.execute(
      params,
    );
  }

  async handleMissedActivitiesJustifications(
    params: HandleMissedActivitiesJustificationsUseCaseInterface.Params,
  ): Promise<HandleMissedActivitiesJustificationsUseCaseInterface.Result> {
    return await this._handleMissedActivitiesJustifications.execute(params);
  }

  async getTeamReportList(
    params: GetTeamReportList.Params,
  ): Promise<GetTeamReportList.Result> {
    return await this._getTeamReportList.execute(params);
  }

  async handleTeamReport(
    params: HandleTeamReport.Params,
  ): Promise<HandleTeamReport.Result> {
    return await this._handleTeamReport.execute(params);
  }

  async getPerformanceReportForProfessionalsSummary(
    params: GetPerformanceReportForProfessionalsSummaryUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsSummaryUseCaseInterface.Result> {
    return await this._getPerformanceReportForProfessionalsSummary.execute(
      params,
    );
  }

  async getPerformanceReportForProfessionalsTopValidatedActivities(
    params: GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsTopValidatedActivitiesUseCaseInterface.Result> {
    return await this._getPerformanceReportForProfessionalsTopValidatedActivities.execute(
      params,
    );
  }

  async getPerformanceReportForProfessionalsEvolution(
    params: GetPerformanceReportForProfessionalsEvolutionUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsEvolutionUseCaseInterface.Result> {
    return await this._getPerformanceReportForProfessionalsEvolution.execute(
      params,
    );
  }

  async getPerformanceReportForProfessionalsRanking(
    params: GetPerformanceReportForProfessionalsRankingUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsRankingUseCaseInterface.Result> {
    return await this._getPerformanceReportForProfessionalsRanking.execute(
      params,
    );
  }

  async exportPerformanceReportForProfessionalsExcel(
    params: ExportPerformanceReportForProfessionalsExcelUseCaseInterface.Params,
  ): Promise<ExportPerformanceReportForProfessionalsExcelUseCaseInterface.Result> {
    return await this._exportPerformanceReportForProfessionalsExcel.execute(
      params,
    );
  }

  async getProfessionalsDailyWorkload(
    params: GetProfessionalsDailyWorkloadUseCaseInterface.Params,
  ): Promise<GetProfessionalsDailyWorkloadUseCaseInterface.Result> {
    return await this._getProfessionalsDailyWorkload.execute(params);
  }

  async exportProfessionalsDailyWorkloadExcel(
    params: ExportProfessionalsDailyWorkloadExcelUseCaseInterface.Params,
  ): Promise<ExportProfessionalsDailyWorkloadExcelUseCaseInterface.Result> {
    return await this._exportProfessionalsDailyWorkloadExcel.execute(params);
  }

  async exportAccessReportExcel(
    params: ExportAccessReportExcelUseCaseInterface.Params,
  ): Promise<ExportAccessReportExcelUseCaseInterface.Result> {
    return await this._exportAccessReportExcel.execute(params);
  }

  async getSuspectedManipulation(
    params: GetSuspectedManipulationUseCaseInterface.Params,
  ): Promise<GetSuspectedManipulationUseCaseInterface.Result> {
    return await this._getSuspectedManipulation.execute(params);
  }

  async getSuspectedManipulationCount(
    params: GetSuspectedManipulationCountUseCaseInterface.Params,
  ): Promise<GetSuspectedManipulationCountUseCaseInterface.Result> {
    return await this._getSuspectedManipulationCount.execute(params);
  }

  async getSuspectedStudentsRanking(
    params: GetSuspectedStudentsRankingUseCaseInterface.Params,
  ): Promise<GetSuspectedStudentsRankingUseCaseInterface.Result> {
    return await this._getSuspectedStudentsRanking.execute(params);
  }

  async exportSuspectedManipulation(
    params: ExportSuspectedManipulationUseCaseInterface.Params,
  ): Promise<ExportSuspectedManipulationUseCaseInterface.Result> {
    return await this._exportSuspectedManipulation.execute(params);
  }

  async exportSuspectedStudentsRanking(
    params: ExportSuspectedStudentsRankingUseCaseInterface.Params,
  ): Promise<ExportSuspectedStudentsRankingUseCaseInterface.Result> {
    return await this._exportSuspectedStudentsRanking.execute(params);
  }

  async getStudentsWorkloadAchievement(
    params: GetStudentsWorkloadAchievementUseCaseInterface.Params,
  ): Promise<GetStudentsWorkloadAchievementUseCaseInterface.Result> {
    return await this._getStudentsWorkloadAchievement.execute(params);
  }

  async exportStudentsWorkloadAchievement(
    params: ExportStudentsWorkloadAchievementUseCaseInterface.Params,
  ): Promise<ExportStudentsWorkloadAchievementUseCaseInterface.Result> {
    return await this._exportStudentsWorkloadAchievement.execute(params);
  }
}
